import { SAPPHIRE_OFFER_JOBS_FETCHED_SUCCESS } from '../constants/actionTypes';

const initialState = {
  SapphireOfferJobs: [],
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SAPPHIRE_OFFER_JOBS_FETCHED_SUCCESS:
      return {
        ...state,
        SapphireOfferJobs: action.payload.SapphireOfferJobs,
        pager: action.payload.pager,
      };

    default:
      return state;
  }
};
